/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation TestCustomerAccountMutation($customerAccountId: ID!, $destinationAddress: String, $mccNameToSearch: String, $mncNameToSearch: String) {
    TestCustomerAccount(customerAccountId: $customerAccountId, destinationAddress: $destinationAddress, mccNameToSearch: $mccNameToSearch, mncNameToSearch: $mncNameToSearch) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
